import * as React from 'react';

const Hu24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#477050", d: "M3 14h18v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M3 10h18v4H3z" }), /* @__PURE__ */ React.createElement("path", { fill: "#CF2939", d: "M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2H3z" }));
Hu24.Size = 24;
Hu24.Title = "Hu";

export { Hu24 as default };
